.primaryStars {
  --star-rating-fill-color: var(--colors-primary-main);
}
